import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
  const def = get(values, 'def') &&
    values.def.map((item, index) => ({
      date: get(values, `def[${index}.isCompleted`) && required(get(values, `def[${index}.date`)),
      name: required(get(values, `def[${index}.name`)),
    }))
  const userAdded = get(values, 'userAdded') &&
    values.userAdded.map((item, index) => ({
      date: get(values, `userAdded[${index}.isCompleted`) && required(get(values, `userAdded[${index}.date`)),
      name: required(get(values, `userAdded[${index}.name`)),
    }))
  const brandNew = get(values, 'brandNew') &&
    values.brandNew.map((item, index) => ({
      date: get(values, `brandNew[${index}.isCompleted`) && required(get(values, `brandNew[${index}.date`)),
      name: required(get(values, `brandNew[${index}.name`)),
    }))

  return {
    def,
    brandNew,
    userAdded
  }
}

export default validate
